import Deepgram from "./deepgram"
import AssemblyAI from "./assembly_ai"
import { transcriber as transcriberSettings } from "../../actions/addon_call_intelligence"

let allowed
export const Permitted = (state = null) => {
    if (state !== null) {
        allowed = !!state
    }

    return allowed
}

let transcriber
export const Init = () => {
    if (!allowed || transcriber) return

    transcriberSettings()
        .then(res => {
            transcriber = newTranscriber(res)
            if (!transcriber) throw new Error("Can't construct Transcriber with recived options")
            if (processAudioTrackCache.length > 0) {
                processAudioTrackCache.forEach(
                    async ({ direction, audioTrack }) => await transcriber.AddAudioTrack(direction, audioTrack)
                )
                processAudioTrackCache = []
            }
            if (callID) {
                transcriber.callID = callID
                callID = 0
            }
        })
        .catch(e => {
            console.log(e)
        })
}

let processAudioTrackCache = []
export async function ProcessAudioTrack(direction, audioTrack) {
    if (!allowed) return
    if (!transcriber) {
        processAudioTrackCache.push({ direction, audioTrack })
        return
    }

    await transcriber.AddAudioTrack(direction, audioTrack)
}

let callID = 0
export const SetCallID = id => {
    if (!id) return

    if (transcriber) {
        if (transcriber.callID && transcriber.callID !== id) {
            console.log("[transcriber] unexpected state", transcriber.callID, id)
        }
        transcriber.callID = id
    } else {
        callID = id
    }
}

export const Finish = transcriptUpload => {
    if (!transcriber) return

    transcriber.Finish()

    if (transcriptUpload && transcriber.callID && Object.keys(transcriber?.transcript).length > 0) {
        const data = {
            transcript: Object.values(transcriber.transcript),
            transcriber: transcriber.Opts?.type,
        }
        transcriptUpload(transcriber.callID, data).catch(e => console.log(e))
    }

    transcriber = null
}

export const newTranscriber = opts => {
    if (opts === null) return null

    switch (opts?.type) {
        case "deepgram":
            return new Deepgram(opts)
        case "assembly_ai":
            return new AssemblyAI(opts)
        default:
            return null
    }
}
